import { AdEnginePlugin, type Hooks } from "../../core/AdEnginePlugin";
import { PrebidPlugin } from "../PrebidPlugin/PrebidPlugin";
import type { InstantConfigRepository } from "instant-config";

type ConsentManagementPrebidPluginConfig = Pick<
  InstantConfigRepository,
  "icPrebidConsentManagementTimeoutMS"
>;

export class ConsentManagementPrebidPlugin extends AdEnginePlugin {
  private isTcfAvailable = false;
  private isUspAvailable = false;

  constructor(private readonly config: ConsentManagementPrebidPluginConfig) {
    super();
  }

  hooks: Hooks = {
    onConsentUpdated: ({ coppa, consentApi }) => {
      this.isTcfAvailable = consentApi === "tcf";
      this.isUspAvailable = consentApi === "usp";

      this.usePlugin(PrebidPlugin)?.addPrebidReadyCallback((pbjs: Prebid) => {
        pbjs.mergeConfig({ coppa });
      });
    },
    onBiddersInit: () => {
      this.usePlugin(PrebidPlugin)?.addPrebidReadyCallback((pbjs: Prebid) => {
        if (this.isTcfAvailable) {
          pbjs.mergeConfig({
            consentManagement: {
              gdpr: {
                cmpApi: "iab",
                timeout: this.config.icPrebidConsentManagementTimeoutMS,
                allowAuctionWithoutConsent: false,
                defaultGdprScope: false,
              },
            },
          });
        }

        if (this.isUspAvailable) {
          pbjs.mergeConfig({
            consentManagement: {
              usp: {
                cmpApi: "iab",
                timeout: this.config.icPrebidConsentManagementTimeoutMS,
              },
            },
          });
        }
      });
    },
  };
}
